export const getItemMax = (item) => {
  return item >= 1000000
    ? parseInt(item / 10000) * 10000
    : item >= 1000
      ? parseInt(item / 10) * 10
      : item;
};

export const getItemMin = (item) => {
  return item >= 1000000
    ? parseInt(item / 10000) * 10000
    : item >= 1000
      ? parseInt(item / 10) * 10
      : item;
};

export const currencyFormate = (value) => {
  return value.toLocaleString("en-AU", {
    style: "currency",
    maximumFractionDigits: 2,
    currency: "AUD",
  });
};

export const commaFormate = (value) => {
  if (value !== null) {
    const stringValue = `${value}`;
    const actualNumber = +stringValue.replace(/,/g, "");

    const formatter = new Intl.NumberFormat("en-AU", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
    return formatter.format(actualNumber);
  }
};

/**
 * 0 => 0.0
 * -10 => -10.00
 * -10.222 => -10.00
 * 10 => 10.00
 * 10.223 => 10.22
 * undefined => NA
 * null => NA
 *
 * @param {*} value is number
 * @param frontSign
 * @param endSign
 * @param decimal
 * @param frontSign
 * @param endSign
 * @param decimal
 * @param frontSign
 * @param endSign
 * @param decimal
 * @returns
 */
export const standardFormate = (value, frontSign = "", endSign = "", decimal = 2) => {
  if (typeof value !== "number") return "NA";

  const stringValue = `${value}`;
  const actualNumber = +stringValue.replace(/,/g, "");

  const formatter = new Intl.NumberFormat("en-AU", {
    maximumFractionDigits: decimal,
    minimumFractionDigits: decimal,
  });

  return frontSign + formatter.format(actualNumber) + endSign;
};

export const standardFormateWithDecoration = ({
  value,
  frontSign = "",
  endSign = "",
  decimal = 2,
  underThreshold = false,
}) => {
  try {
    if (typeof value !== "number" || underThreshold) return "NA";

    const stringValue = `${value}`;
    const actualNumber = +stringValue.replace(/,/g, "");

    const formatter = new Intl.NumberFormat("en-AU", {
      maximumFractionDigits: decimal,
      minimumFractionDigits: decimal,
    });

    return frontSign + formatter.format(actualNumber) + endSign;
  } catch (error) {
    return "NA";
  }
};

export const uppercaseSingleFirstLetter = (value) => {
  if (typeof value === "string") {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
  return value;
};
export const decimalFormat = (value, num = 2) => {
  if (Number(value)) {
    return Number(parseFloat(value).toFixed(num));
  }
  return 0;
};

export const numberFormatSpecifyReturn = ({
  value,
  frontSign = "",
  endSign = "",
  decimal = 2,
  returnValue = "NA",
}) => {
  try {
    if (typeof value !== "number") return returnValue;

    const stringValue = `${value}`;
    const actualNumber = +stringValue.replace(/,/g, "");

    const formatter = new Intl.NumberFormat("en-AU", {
      maximumFractionDigits: decimal,
      minimumFractionDigits: decimal,
    });

    return frontSign + formatter.format(actualNumber) + endSign;
  } catch (error) {
    return returnValue;
  }
};

export const formatSalesUnits = (value) => {
  return Math.round(value).toLocaleString("en-US").replace("-0", "0");
};
